module.exports = __webpack_public_path__ + "media/images/mobile/city_img/g5-594a2dc7e5df1d1058658223c9661518.png";